import { Alert } from '@mui/material';
import { useEffect } from 'react';
import { useContext } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AtomicButton from '../../atomic/button/AtomicButton';
import InputBox from '../../atomic/inputbox/InputBox';
import { LoginDataContext } from '../../context-api/LoginDataProvider';
import { emailRegex } from '../../global/constants';
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper';

import './LoginForm.scss';
import responseErrorMapping from '../../global/error.response.mapping';
import { Error404 } from '../Error404/Error404';

const ForgotPasswordForm = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState(undefined);
  const [isEmailFormatValid, setEmailFormatValid] = useState(true);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const { forgotPasswordData, onForgotPassword } = useContext(LoginDataContext);
  const { loading, data, errors, errorMessage } = forgotPasswordData;
  const TryCatchError =
    errorMessage?.success === false &&
    errorMessage?.CustomMessage === 'Something is seriouly wrong,This is last CATCH block';
  const NotificationSeverIsUp = data?.data?.notificationEmailResponse?.success;

  const onChangeHandler = (event) => {
    setEmail(event.target.value);
  };

  const onSubmitHandler = () => {
    setShowSuccessAlert(false);
    const isEmailValid = emailRegex.test(email);
    setEmailFormatValid(isEmailValid);
    if (isEmailValid) {
      onForgotPassword({ email });
    }
  };

  const RedirectToSignup = () => navigate('/signup');
  const RedirectToLogin = () => navigate('/login');

  useEffect(() => {
    if (data && data.data && data.data.success) {
      setShowSuccessAlert(true);
    }
  }, [data]);

  const showError = !isEmailFormatValid || errors;

  if (errorMessage === 'Network Error') {
    return <Error404 />;
  }

  return (
    <div className={isMobile ? 'forgotpassword-container-mobile' : 'login-container'}>
      <div className='login-form'>
        <div className='login-form-title'>Forgot Password</div>
        <div className='free-text'>
          Enter the email address associated with your account, and we'll email you a link to reset
          the password.{' '}
        </div>
        {showError && (
          <Alert
            severity='error'
            sx={{ width: '100%', border: 'solid 1px red', marginBottom: '5px', marginTop: '10px' }}
          >
            {!isEmailFormatValid ? (
              <div style={{ color: 'red' }}>Invalid Email</div>
            ) : (
              <div>
                {!TryCatchError && (
                  <div style={{ color: 'red' }}>{responseErrorMapping(errorMessage)}</div>
                )}
                {TryCatchError && (
                  <div style={{ color: 'red', fontSize: '14px' }}>
                    {responseErrorMapping(errorMessage)}
                  </div>
                )}
              </div>
            )}
          </Alert>
        )}

        {NotificationSeverIsUp === false && (
          <Alert
            severity='error'
            sx={{ width: '100%', border: 'solid 1px red', margin: '10px 0px 10px 0px' }}
          >
            <div style={{ color: 'red' }}>Email server is down please try later</div>
          </Alert>
        )}
        {showSuccessAlert && NotificationSeverIsUp !== false && (
          <Alert
            severity='success'
            sx={{
              width: '100%',
              border: '2px solid #33AE1C',
              color: '#33AE1C',
              marginBottom: '5px',
              marginTop: '10px',
              backgroundColor: 'white',
            }}
          >
            <strong>
              If your email address exists in our database, you will receive a password recovery
              link at your email address in a few minutes
            </strong>
          </Alert>
        )}

        <InputBox
          type='email'
          label='Email'
          size='small'
          sx={{ width: isMobile ? '300px' : '100%', height: 'auto', margin: '6px 0px 5px 0px' }}
          name='email'
          value={email}
          inputErrorMsg=''
          error={!isEmailFormatValid}
          onChange={onChangeHandler}
        />

        <AtomicButton
          loading={loading}
          handleSubmit={onSubmitHandler}
          label='SEND RESET INSTRUCTIONS'
          endIcon
          startIcon
          loadingIcon
          loadingButtonStyle={{}}
          style={{
            backgroundColor: '#181436',
            width: isMobile ? '300px' : '100%',
            marginTop: '15px',
            marginBottom: '15px',
          }}
        />

        <div className='login-optional-links' style={{ justifyContent: 'center' }}>
          <span onClick={RedirectToLogin}>Log In&nbsp;|</span>
          <span onClick={RedirectToSignup}>&nbsp; Sign Up</span>
        </div>
      </div>
    </div>
  );
};
export default ForgotPasswordForm;
